import Vue from 'vue'
import VueRouter from 'vue-router'
import MainPage from './components/MainPage.vue'
import AdminPage from './components/AdminPage.vue'
import { auth } from './firebase'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: MainPage,
    props: true
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: { requiresAuth: true }
  }
]

const router = new VueRouter({
  mode: 'history',
  routes
})

// Navigation guard for protected routes
router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  
  if (requiresAuth) {
    // Check auth state
    const unsubscribe = auth.onAuthStateChanged(user => {
      unsubscribe()
      if (user) {
        next()
      } else {
        // Allow access but show login form on the admin page
        next()
      }
    })
  } else {
    next()
  }
})

export default router
